import {FC} from 'react';
import {styled} from 'styled-components';
import {Route} from 'wouter';

import {HomePage} from '@website_frontend/components/home_page';

export const App: FC = () => {
  return (
    <Wrapper>
      <Route path="/" component={HomePage} />
    </Wrapper>
  );
};
App.displayName = 'App';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;
